import { Button, Container, useMediaQuery } from "@material-ui/core";
import { makeStyles, useTheme } from "@material-ui/core/styles";
import React from "react";
import proTip from "../../../../assets/images/protip_topup.png";
import ContentList from "../../components/contentList";
import Link from "@material-ui/core/Link";
import { Link as RouterLink } from "react-router-dom";
import { useDispatch } from "react-redux";
import { setTabPosition } from "../../uiSlice";

const useStyles = makeStyles((theme) => ({
  logoHeading: {
    width: 150,
    [theme.breakpoints.up("sm")]: {
      width: 180,
    },
    [theme.breakpoints.up("md")]: {
      width: 250,
    },
    minWidth: 100,
  },
  body: {
    color: theme.palette.secondary.main,
    [theme.breakpoints.up("lg")]: {
      marginLeft: 70,
      marginBottom: theme.spacing(10),
    },
  },
  overlineText: {
    display: "flex",
    alignItems: "left",
    flexWrap: "wrap",
    fontFamily: "Akzidenz-Grotesk BQ, serif",
    marginTop: 20,
    [theme.breakpoints.up("md")]: {
      marginTop: 0,
    },
    textTransform: "uppercase",
  },
  it: {
    fontStyle: "italic",
    fontFamily: "Arial Rounded MT",
    textTransform: "none",
  },
  right: {
    textAlign: "right",
  },
  img: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    width: "75%",
  },
  ol: {
    paddingLeft: theme.spacing(3),
    marginBottom: theme.spacing(2),
  },
}));

export default function TopupContent() {
  const classes = useStyles();
  const theme = useTheme();
  const xs = useMediaQuery(theme.breakpoints.down("xs"));
  const dispatch = useDispatch();

  const LinkText = (props) => {
    const { navIndex, route, text } = props;
    return (
      <Link
        onClick={() => {
          window.scrollTo(0, 0);
          dispatch(setTabPosition(navIndex));
        }}
        component={RouterLink}
        to={route}
        // color="primary"
        className={classes.linktext}
      >
        <b>{text}</b>
      </Link>
    );
  };

  return (
    <Container>
      <ContentList
        title="Quick Pay"
        items={[
          <span>
            All you need is your phone number, visa debit card or any credit card and email address.
            Choose the amount that's right for you!
          </span>,
          <Button
            component={RouterLink}
            to="/quicktopup"
            color="primary"
            size="large"
            variant="contained"
            onClick={() => {
              window.scrollTo(0, 0);
              dispatch(setTabPosition(8));
            }}
            style={{ borderRadius: 20, marginRight: 10 }}
          >
            Click Here
          </Button>,
        ]}
      />
      ,
      <ContentList
        title="ONLINE PAY"
        items={[
          <span>
            Keep track of all your top ups and <b>YOOZ It</b> anywhere, anytime
            you want!
          </span>,
          <Button
            component={RouterLink}
            to="/signup"
            color="primary"
            size="large"
            variant="contained"
            onClick={() => {
              window.scrollTo(0, 0);
              dispatch(setTabPosition(8));
            }}
            style={{ borderRadius: 20, marginRight: 10 }}
          >
            Click Here
          </Button>,
          
        ]}
      />
      ,
      <ContentList
        title="MOBILE PAY"
        items={[
          <span>
            <b>No WiFi? No Data? No PROBLEM!</b>{" "}
          </span>,
          <span>Just dial *190# for FREE!</span>,
         <span>
           <LinkText navIndex={6} route="/contact" text="Call or Email us" />{" "}to make an appointment to Register.
                  
         </span>
        ]}
      />
      ,
      <ContentList
        title=""
        items={[
          <span>All you need to sign up...</span>,
          <span className={classes.ol}>
            &bull; A debit or credit card (credit card users also require ID.)
          </span>,
          <span className={classes.ol}>
            &bull; Any prepaid or postpaid mobile phone.
          </span>,
          <span className={classes.ol}>&bull; A minute to register!</span>,
          <span>It’s so easy to YOOZ!</span>,
          <iframe
            title="topup video"
            width={xs ? "100%":500}
            height={xs ? 300:500}
            src="https://www.youtube.com/embed/umU4j6SJ0LQ"
            frameBorder="0"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
          ></iframe>,
          <div>
            <LinkText navIndex={6} route="/contact" text="Register" /> to YOOZ
            it today!
          </div>,
          <img src={proTip} alt="yooz topup protip" className={classes.img} />,
        ]}
      />
    </Container>
  );
}
